export default {
  loading: {
    id: 'bo_sellers-orders-sub_views-fetching_data',
    defaultMessage: 'Fetching orders',
  },
} as const
